import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import "./notifications.scss";

function Notifications() {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const loadNotifications = async () => {
        try {
            setLoading(true);

            const response = await axiosInstance.get("notifications", {
                withCredentials: true,
            });

            setNotifications(response.data);
        } catch (error) {
            console.error(
                "Fehler beim Laden der Benachrichtigungen:",
                error
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadNotifications();
    }, []);

    const handleNotificationClick = async (notification) => {
        try {
            if (!notification.is_read) {
                await axiosInstance.patch(
                    `notifications/${notification.id}/read`,
                    {},
                    { withCredentials: true }
                );

                setNotifications((previous) =>
                    previous.map((item) =>
                        item.id === notification.id
                            ? { ...item, is_read: 1 }
                            : item
                    )
                );
            }

            if (notification.link) {
                navigate(notification.link);
            }
        } catch (error) {
            console.error(
                "Fehler beim Aktualisieren der Benachrichtigung:",
                error
            );
        }
    };

    if (loading) {
        return (
            <div className="notificationList">
                <span>Benachrichtigungen werden geladen...</span>
            </div>
        );
    }

    return (
        <div className="notificationList">
            {notifications.length === 0 ? (
                <div className="notificationEmpty">
                    Keine Benachrichtigungen
                </div>
            ) : (
                notifications.map((notification) => (
                    <div
                        key={notification.id}
                        className={`notificationItem ${Number(notification.is_read) === 1
                            ? "read"
                            : "unread"
                            }`}
                        onClick={() =>
                            handleNotificationClick(notification)
                        }
                    >
                        <div className="notificationTitle">
                            {notification.title}
                        </div>

                        <div className="notificationMessage">
                            {notification.message}
                        </div>

                        <div className="notificationDate">
                            {new Date(
                                notification.created_at
                            ).toLocaleString("de-DE")}
                        </div>
                    </div>
                ))
            )}
        </div>
    );
}

export default Notifications;
